var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCplabsLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 28,
    viewBox: "0 0 192 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_17830)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_243_17830)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.02584 0H28.3052V5.56997H6.02584H0.456055L6.02584 0ZM6.02584 5.56997L0.456055 11.1397V27.8494H22.7354L28.3052 22.2794H6.02584V5.56997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.875 0V27.8494L39.4448 22.2794V16.7097H56.1544L61.7242 11.1397V5.56997L56.1544 0H33.875ZM56.1544 11.1397H39.4448V5.56997H56.1544V11.1397Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.196 16.7099L153.626 11.1402L136.917 11.1399V5.57021H153.626L153.626 11.1402L159.196 5.57021L153.626 0.000244141H136.917L131.347 5.56997V27.8494L136.917 22.2796V27.8494H153.626L159.196 22.2796L159.196 16.7099ZM153.626 22.2796H136.917L136.917 16.7099H153.626V22.2796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.222 5.56997V5.56973L185.653 0H168.943L163.373 5.56973V11.1397L168.943 16.7097H185.653V22.2794H168.943L163.373 27.8494H185.653L191.222 22.2796V22.2794V16.7097L185.653 11.1397H168.943V5.56997H191.222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.753 0.000244141L97.928 27.8494H103.498L105.463 22.2799H110.708L116.278 16.7102L120.207 27.8494H125.777L115.953 0.000244141H107.753ZM107.428 16.7099L111.853 4.16681L116.278 16.7102L107.428 16.7099Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1431 22.2796H72.8638V0.000244141L67.2939 5.57009V27.8494H89.5733L95.1431 22.2796Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_17830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.088,
    height: 28,
    fill: "white",
    transform: "translate(0.456055)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_243_17830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191.088,
    height: 28,
    fill: "white",
    transform: "translate(0.456055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCplabsLogo);
export default __webpack_public_path__ + "static/media/ic-cplabs-logo.d5346751ed388cb660d6d2abca1c904c.svg";
export { ForwardRef as ReactComponent };